import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-href-button', (editor, opts = {}) => {
  const config = {
    blocks: [
      'hrefbutton',
    ],
    name: 'hrefComponent',
    stylePrefix: 'gjs-',
    labelHrefButton: 'Botón Enlace',
    defText: 'Sample',
    category: 'Botones',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
